var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {},
    [
      _vm.showCsv
        ? [
            _c("ValidationObserver", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function ({ invalid }) {
                      return [
                        _vm._l(_vm.csvParseOutput, function (item, index) {
                          return _c("UserInvitationData", {
                            key: index,
                            attrs: {
                              userEmail: item.email,
                              userGivenName: item.givenName,
                              userFamilyName: item.familyName,
                              processing: item.processing,
                              userId: item.id,
                              companyId: _vm.companyId,
                              index: index,
                              userSource: _vm.csvParseOutput,
                              isManager: _vm.isManager,
                              usersToCheck: _vm.csvParseOutput,
                              allowedAdding: _vm.isAddingUserAllowed(index),
                              allowDelete: _vm.isDeleteAllowed(
                                _vm.csvParseOutput
                              ),
                              validateCsv: "",
                              immediate: "",
                            },
                            on: {
                              "update:userEmail": function ($event) {
                                return _vm.$set(item, "email", $event)
                              },
                              "update:user-email": function ($event) {
                                return _vm.$set(item, "email", $event)
                              },
                              "update:userGivenName": function ($event) {
                                return _vm.$set(item, "givenName", $event)
                              },
                              "update:user-given-name": function ($event) {
                                return _vm.$set(item, "givenName", $event)
                              },
                              "update:userFamilyName": function ($event) {
                                return _vm.$set(item, "familyName", $event)
                              },
                              "update:user-family-name": function ($event) {
                                return _vm.$set(item, "familyName", $event)
                              },
                              "update:processing": function ($event) {
                                return _vm.$set(item, "processing", $event)
                              },
                              "update:userId": function ($event) {
                                return _vm.$set(item, "id", $event)
                              },
                              "update:user-id": function ($event) {
                                return _vm.$set(item, "id", $event)
                              },
                              delete: _vm.deleteCsvEntry,
                            },
                          })
                        }),
                        _vm._t("lastParsedCSVLine"),
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center pt-4 border-t border-gray-200",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "flex" },
                              [
                                _c("UiButton", {
                                  staticClass: "mr-3",
                                  attrs: {
                                    variant: "outline",
                                    buttonText: "Cancel",
                                  },
                                  on: { click: _vm.handleClose },
                                }),
                                _c("UiButton", {
                                  staticClass: "ml-auto",
                                  attrs: {
                                    buttonText: _vm.loading
                                      ? "Loading..."
                                      : "Submit",
                                    disabled: invalid,
                                  },
                                  on: { click: _vm.handleCsvSubmit },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "flex ml-auto items-center" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-gray-700 text-sm space-x-2 flex mr-2 self-end",
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(_vm.csvFilename) +
                                          ", " +
                                          _vm._s(_vm.csvParseOutput.length) +
                                          " in total"
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("UiButton", {
                                  staticClass: "mr-auto",
                                  attrs: {
                                    variant: "outline",
                                    type: "button",
                                    buttonText: "Remove All",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit("parsedCsvChange", [])
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            }),
          ]
        : [
            _vm._t("default", function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "w-full flex justify-center px-4 pt-5 mb-5 border border-primary-color drop-file-container",
                    on: {
                      drop: function ($event) {
                        $event.preventDefault()
                        return _vm.addFile.apply(null, arguments)
                      },
                      dragover: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "text-center" }, [
                      _c("span", { staticClass: "flex justify-center mb-3" }, [
                        _c(
                          "span",
                          { staticClass: "p-5 rounded-full bg-primary" },
                          [
                            _c("PicturePlaceholderIcon", {
                              staticClass: "text-white h-5 w-5",
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c("p", { staticClass: "mt-1 text-low text-gray-600" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "text-primary-500 hover:text-primary-800 focus:outline-none focus:underline transition duration-150 ease-in-out underline hover:no-underline",
                            attrs: { type: "button" },
                            on: { click: _vm.handleFileUpload },
                          },
                          [_vm._v(" Upload CSV ")]
                        ),
                        _vm._v(" or drag and drop "),
                      ]),
                      _c("input", {
                        ref: "fileUpload",
                        attrs: { type: "file", accept: ".csv", hidden: "" },
                        on: { change: _vm.addFile },
                      }),
                    ]),
                  ]
                ),
              ]
            }),
            _c("ModalSectionsDivider"),
            _c(
              "div",
              { staticClass: "pt-5 text-sm flex" },
              [
                _c("UiButton", {
                  staticClass: "mr-3",
                  attrs: { variant: "outline", buttonText: "Cancel" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                }),
                _c(
                  "a",
                  {
                    ref: "sample",
                    staticClass:
                      "px-7 py-3 text-low h-12 rounded-3xl border-transparent text-white bg-secondary hover:bg-secondary-700 focus:outline-none focus:border-secondary-700 active:bg-secondary-700 font-semibold disabled:text-gray-800 cursor-pointer",
                    on: { click: _vm.downloadSampleCsv },
                  },
                  [_vm._v(" Download Sample CSV ")]
                ),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }